import { gql } from '@apollo/client';

export const OtpFields = gql`
  fragment OtpFields on VerifyOtpResponse {
    ... on VerifyOtpSuccessfulResponse {
      isValid
      verificationId
    }
    ... on VerifyOtpUnsuccessfulResponse {
      isValid
    }
  }
`;
